// Location status
export const IN_REVIEW = "IN_REVIEW";
export const APPROVED = "APPROVED";
export const REJECTED = "REJECTED";
// Suport needs
export const NEEDS = { LOW: "low", MEDIUM: "medium", HIGH: "high" };
// Education
export const EDUCATION = {
  FULL_TIME: "FULL_TIME",
  PART_TIME: "PART_TIME",
  HOME_SCHOOL: "HOME_SCHOOL",
  NOT_IN_EDUCATION: "NOT_IN_EDUCATION",
};
export const GENDER = {
  MALE: "Male",
  FEMALE: "Female",
  TRANSGENDER_MALE: "Transgender (Male)",
  TRANSGENDER_FEMALE: "Transgender (Female)",
  NONBINARY: "Nonbinary",
  OTHER: "Other",
};
export const TYPE_OF_CARE = {
  RESIDENTIAL: "Residential",
  SUPPORTED_LIVING: "Supported Living",
  OTHER: "Other",
};

export const DOCUMENT_TYPES = {
  REFERRAL: "referral",
  MEDICAL: "medical",
  EDUCATIONAL: "educational",
  COURT: "court",
  PHOTO: "photo",
  OTHER: "other",
};

export const DOCUMENT_TYPE_LABELS = {
  [DOCUMENT_TYPES.REFERRAL]: "Referral Document",
  [DOCUMENT_TYPES.MEDICAL]: "Medical Report",
  [DOCUMENT_TYPES.EDUCATIONAL]: "Educational Assessment",
  [DOCUMENT_TYPES.COURT]: "Court Document",
  [DOCUMENT_TYPES.PHOTO]: "Child Photo",
  [DOCUMENT_TYPES.OTHER]: "Other Document",
};

export const INVALID_VALUE = "-1";
